import XDataGrid from "../components/XDataGrid";

export default function Orders() {
  return <XDataGrid data={[]} />;
}
